import styled from "styled-components"

export const StyledFoodListItem = styled.div<{ $isSelected: boolean }>`
  --left-check-box-width: 46px;

  display: flex;
  align-items: center;

  background: #fff;
  width: 100%;
  border-radius: 8px;
  outline: ${(props) =>
    props.$isSelected
      ? "1px solid var(--Schemes-Primary-Container-Variant-2, #0fbdd4)"
      : "0.8x solid var(--Schemes-Outline-Variant, rgba(0, 38, 58, 0.14))"};
  background: var(--Schemes-Surface-Container-Lowest, #fff);
`

export const FoodLeft = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 46px;
  padding-left: 8px;
  padding-right: 4px;
  flex-shrink: 0;
`

export const FoodRight = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing_s, 8px);
  flex-grow: 1;
  max-width: calc(100% - var(--left-check-box-width));
  cursor: default;
  padding: 6px var(--spacing_s, 8px);
  padding-left: 0;
`

export const FoodImageBox = styled.div`
  height: 44px;
  width: 44px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 38, 58, 0.14);
  flex-shrink: 0;
  overflow: hidden;
`

export const FoodImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const FoodInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: calc(100% - 40px - 8px - 32px - 24px);
  flex-grow: 1;
`

export const FoodName = styled.p`
  font-size: 14px;
  line-height: 160%;
  color: var(--Schemes-On-Surface, #1c1f21);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  .high-light-text {
    background-color: transparent;
    font-weight: 600;
  }
`

export const FoodNutrient = styled.div`
  color: var(--Schemes-On-Surface-Variant, #69757d);
  font-size: 12px;
  font-weight: 500;
  line-height: 12px; /* 100% */
  letter-spacing: 0.12px;
  flex-shrink: 0;
`

export const AddFoodButton = styled.div`
  display: flex;
  padding: var(--spacing_xxs, 4px);
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 20px;
  width: 32px;
  height: 32px;
  background: var(--Schemes-Surface-Container-Low, #f5f7f7);
  flex-shrink: 0;
  background: rgb(245, 247, 247);
  cursor: pointer;
`

export const FoodListDivider = styled.div`
  margin: 4px 0;
  height: 1px;
  background: var(--Schemes-Outline, rgba(0, 38, 58, 0.14));
  width: 100%;

  @supports (-webkit-touch-callout: none) {
    height: 0.8px;
  }
`

export const SelectButtonWrapper = styled.div`
  padding-right: 4px;
  display: flex;
  justify-content: center;
  width: 100%;
`

export const UncheckedIcon = styled.div`
  border-radius: 8px;
  border: 1px solid var(--Schemes-Outline, rgba(0, 38, 58, 0.32));
  background: var(--Base-White, #fff);
  width: 16px;
  height: 16px;
`

export const CheckedIcon = styled(UncheckedIcon)`
  border: 1px solid var(--Schemes-Primary-Container-Variant-2, #0fbdd4);
  background: var(--Schemes-Primary-Container-Variant-2, #0fbdd4);
  display: flex;
  align-items: center;
  justify-content: center;
`

export const FoodBottomInfo = styled.div`
  height: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
`

export const FoodBrand = styled.div`
  border-radius: 2px;
  background: var(--Schemes-Surface-Container, #ebedf0);
  display: flex;
  padding: 1px 4px 0px 4px;
  align-items: center;
  height: 15px;

  p {
    font-weight: 500;
    font-size: 12px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #69757d;
  }
`
